import { style } from "@vanilla-extract/css";

import { text } from "~/styles/type.css";
import { vars } from "~/styles/tokens.css";

export const tile = style({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  padding: vars.space.md,
  backgroundColor: vars.color.surface,
  border: `1px solid ${vars.color.borderSubtle}`,
  borderRadius: vars.radius.lg,
  minWidth: 0,
});

export const value = style([
  text.display,
  {
    color: vars.color.textDefault,
  },
]);

// Gold is ceremony — reserved for the KPI that deserves a crown (signed
// this week), never a functional status.
export const valueGold = style([
  value,
  {
    color: vars.color.gold,
  },
]);

export const caption = style([
  text.label,
  {
    color: vars.color.textMuted,
  },
]);
